/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExchangeableAppointmentResponse
 */
export interface ExchangeableAppointmentResponse {
    /**
     * 
     * @type {string}
     * @memberof ExchangeableAppointmentResponse
     */
    appointmentId: string;
    /**
     * 
     * @type {Date}
     * @memberof ExchangeableAppointmentResponse
     */
    startTimeUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExchangeableAppointmentResponse
     */
    endTimeUtc: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ExchangeableAppointmentResponse
     */
    isAllDay: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExchangeableAppointmentResponse
     */
    purposeKey: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeableAppointmentResponse
     */
    location: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExchangeableAppointmentResponse
     */
    details: string | null;
}

/**
 * Check if a given object implements the ExchangeableAppointmentResponse interface.
 */
export function instanceOfExchangeableAppointmentResponse(value: object): value is ExchangeableAppointmentResponse {
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('startTimeUtc' in value) || value['startTimeUtc'] === undefined) return false;
    if (!('endTimeUtc' in value) || value['endTimeUtc'] === undefined) return false;
    if (!('isAllDay' in value) || value['isAllDay'] === undefined) return false;
    if (!('purposeKey' in value) || value['purposeKey'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function ExchangeableAppointmentResponseFromJSON(json: any): ExchangeableAppointmentResponse {
    return ExchangeableAppointmentResponseFromJSONTyped(json, false);
}

export function ExchangeableAppointmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeableAppointmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentId': json['appointmentId'],
        'startTimeUtc': (new Date(json['startTimeUtc'])),
        'endTimeUtc': (new Date(json['endTimeUtc'])),
        'isAllDay': json['isAllDay'],
        'purposeKey': json['purposeKey'],
        'location': json['location'],
        'details': json['details'],
    };
}

export function ExchangeableAppointmentResponseToJSON(json: any): ExchangeableAppointmentResponse {
    return ExchangeableAppointmentResponseToJSONTyped(json, false);
}

export function ExchangeableAppointmentResponseToJSONTyped(value?: ExchangeableAppointmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentId': value['appointmentId'],
        'startTimeUtc': value['startTimeUtc'].toISOString(),
        'endTimeUtc': value['endTimeUtc'].toISOString(),
        'isAllDay': value['isAllDay'],
        'purposeKey': value['purposeKey'],
        'location': value['location'],
        'details': value['details'],
    };
}

